import { render } from "./AddAlloyBlackbox.vue?vue&type=template&id=66cc2519"
import script from "./AddAlloyBlackbox.vue?vue&type=script&lang=js"
export * from "./AddAlloyBlackbox.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__